import executeQuery from "#lib/db"
import type { Recipe } from "#types"

export const getGeneral = async ({ id }: { id: string }): Promise<Recipe> => {
	const list = await executeQuery({
		query: `
			select
				recipeID,
				categoryID,
				recipe,
				description,
				yield,
				servings,
				link,
				fromWho,
				dateCreated,
				dateModified,
				userCreated,
				userModified,
				greatest(
					recipes.dateCreated,
					recipes.dateModified,
					(select
						max(greatest(
							recipe_ingredients.dateCreated,
							recipe_ingredients.dateModified
						))
						from recipe_ingredients
						where recipe_ingredients.recipeID=${id}
					),
					(select
						max(greatest(
							recipe_instructions.dateCreated,
							recipe_instructions.dateModified
						))
						from recipe_instructions
						where recipe_instructions.recipeID=${id}
					)
				) as lastUpdated
		from
			recipes
		where
			recipeID=${id}`,
	})

	return list.length > 0 ? list[0] : {}
}

export const putGeneral = async ({ id }: { id: string }): Promise<Recipe> => {
	const list = await executeQuery({
		query: `
			select
				recipeID,
				categoryID,
				recipe,
				description,
				yield,
				servings,
				link,
				fromWho,
				dateCreated,
				dateModified,
				userCreated,
				userModified,
				greatest(
					recipes.dateCreated,
					recipes.dateModified,
					(select
						max(greatest(
							recipe_ingredients.dateCreated,
							recipe_ingredients.dateModified
						))
						from recipe_ingredients
						where recipe_ingredients.recipeID=${id}
					),
					(select
						max(greatest(
							recipe_instructions.dateCreated,
							recipe_instructions.dateModified
						))
						from recipe_instructions
						where recipe_instructions.recipeID=${id}
					)
				) as lastUpdated
		from
			recipes
		where
			recipeID=${id}`,
	})

	return list.length > 0 ? list[0] : {}
}
